import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'oligonRunningElafronKentimata';
const args = {};

export class OligonRunningElafronKentimata extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
